import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-[#252530] py-8 px-4 sm:px-6 lg:px-8 bg-[#0a0a0f]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Left - Name and role */}
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#00d4aa] to-[#6ee7c2] flex items-center justify-center text-[#0a0a0f] font-bold text-lg">
              C
            </div>
            <div>
              <p className="text-[#f0f0f5] font-semibold">Chethan</p>
              <p className="text-[#a0a0b0] text-sm">Full Stack AI Engineer</p>
            </div>
          </div>
          
          {/* Center - Status */}
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#00d4aa] animate-pulse" />
            <span className="text-[#a0a0b0] text-sm">Open for opportunities</span>
          </div>
          
          {/* Right - Copyright */}
          <div className="flex items-center gap-1 text-[#a0a0b0] text-sm">
            <span>© 2026 · Built with</span>
            <Heart className="w-4 h-4 text-[#00d4aa]" />
            <span>& RAG</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
